export const COLLECTION_POINTS_RESET_STATE = 'COLLECTION_POINTS_RESET_STATE';
export const COLLECTION_POINTS_CURRENT_ITEM = 'COLLECTION_POINTS_CURRENT_ITEM';

export const COLLECTION_POINTS_REQUEST_LOADING = 'COLLECTION_POINTS_REQUEST_LOADING';
export const COLLECTION_POINTS_REQUEST_SUCCESS = 'COLLECTION_POINTS_REQUEST_SUCCESS';
export const COLLECTION_POINTS_REQUEST_FAILED = 'COLLECTION_POINTS_REQUEST_FAILED';

export const COLLECTION_POINTS_CURRENT_ACTION = 'COLLECTION_POINTS_CURRENT_ACTION';
export const COLLECTION_POINTS_RESET_ACTION = 'COLLECTION_POINTS_RESET_ACTION';